import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Read-only access to the pulled external_tour rows. Non-admins are
 * server-side scoped to the orgs they belong to.
 */
export class ExternalTour {
    static async getList(req) {
        var _a;
        const result = await NetFetch.postData('/json/external-tour/list', req !== null && req !== void 0 ? req : {});
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = (result.list)) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
}
